"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Content = _interopRequireDefault(require("@insided/deprecated-preact-components/common/Content"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PageUnloadContext = require("@insided/shared/services/PageUnloadContext");

var _Editor = _interopRequireDefault(require("@insided/shared/uikit/Editor"));

var _PinnedReply = _interopRequireDefault(require("../PinnedReply"));

var _Poll = _interopRequireDefault(require("../../../Post/Poll"));

var _OnDemandTranslations = require("@insided/shared/modules/HubAI/OnDemandTranslations");

var _common = require("@insided/shared/utils/common");

var _BestAnswer = _interopRequireDefault(require("../BestAnswer"));

var TopicBodyContent = function TopicBodyContent(_ref) {
  var _authors$String$name, _authors$String, _authors$String2;

  var showEditor = _ref.showEditor,
      attachments = _ref.attachments,
      isLoading = _ref.isLoading,
      editorErrors = _ref.editorErrors,
      handleOpeningPostChange = _ref.handleOpeningPostChange,
      disableFileAttachments = _ref.disableFileAttachments,
      _onCancel = _ref.onCancel,
      _onChange = _ref.onChange,
      pinnedReply = _ref.pinnedReply,
      originalContent = _ref.originalContent,
      bestAnswer = _ref.bestAnswer,
      poll = _ref.poll,
      pollVotes = _ref.pollVotes,
      answeredPoll = _ref.answeredPoll,
      pollSelectionLoading = _ref.pollSelectionLoading,
      handlePollAnswer = _ref.handlePollAnswer,
      translatedPinnedReplyText = _ref.translatedPinnedReplyText,
      translatedBestAnswerText = _ref.translatedBestAnswerText,
      isTranslationInProgress = _ref.isTranslationInProgress,
      translatedTopicContent = _ref.translatedTopicContent,
      authors = _ref.authors;
  var bestAnswerAuthorUserName = (_authors$String$name = authors === null || authors === void 0 ? void 0 : (_authors$String = authors[String(bestAnswer === null || bestAnswer === void 0 ? void 0 : bestAnswer.authorId)]) === null || _authors$String === void 0 ? void 0 : _authors$String.name) !== null && _authors$String$name !== void 0 ? _authors$String$name : 'Anonymous';
  return (0, _preact.h)("div", null, showEditor ? (0, _preact.h)(_PageUnloadContext.PageUnloadContext.Consumer, null, function (_ref2) {
    var lock = _ref2.lock,
        unlock = _ref2.unlock;
    return (0, _preact.h)("div", {
      className: (0, _classnames.default)('post__content', 'post__edit', 'qa-topic-post-edit')
    }, (0, _preact.h)(_Editor.default, {
      disableFileAttachments: disableFileAttachments,
      data: translatedTopicContent,
      attachments: attachments,
      canHavePoll: false,
      isLoading: isLoading,
      errors: editorErrors,
      onSubmit: function onSubmit() {
        unlock();
        handleOpeningPostChange();
      },
      onCancel: function onCancel() {
        unlock();

        _onCancel();
      },
      onChange: function onChange(content, attachments) {
        _onChange(content, attachments);

        lock(content, originalContent);
      },
      profile: "openingPost",
      isControl: false
    }));
  }) : (0, _preact.h)("div", {
    className: (0, _classnames.default)('topic-view-content-wrapper', {
      'translation-loading': isTranslationInProgress
    })
  }, (0, _preact.h)(_Content.default, {
    content: translatedTopicContent !== null && translatedTopicContent !== void 0 ? translatedTopicContent : '',
    className: (0, _classnames.default)('post__content', 'qa-topic-post-content', 'post__content--new-editor')
  }), !_common.common.isModuleActive('threadedRepliesDestination') && pinnedReply && authors && (0, _preact.h)(_PinnedReply.default, {
    author: (_authors$String2 = authors[String(pinnedReply.authorId)]) !== null && _authors$String2 !== void 0 ? _authors$String2 : {
      id: '',
      name: 'Anonymous',
      avatarUrl: ''
    },
    repliedAt: pinnedReply.repliedAt,
    content: translatedPinnedReplyText || pinnedReply.content || ''
  }), !_common.common.isModuleActive('threadedRepliesDestination') && bestAnswer && (0, _preact.h)(_BestAnswer.default, {
    bestAnswer: {
      content: translatedBestAnswerText || bestAnswer.content || '',
      publicReplyId: String(bestAnswer.publicReplyId || ''),
      username: bestAnswerAuthorUserName
    }
  }), poll && !showEditor && (0, _preact.h)(_Poll.default, {
    poll: poll,
    pollVotes: pollVotes,
    answeredPoll: answeredPoll,
    pollSelectionLoading: pollSelectionLoading,
    handlePollSelection: handlePollAnswer
  })));
}; // export default PostContent


var _default = (0, _OnDemandTranslations.withOnDemandTranslationProps)(TopicBodyContent, ['isTranslationInProgress', 'translatedTopicContent', 'translatedBestAnswerText', 'translatedPinnedReplyText']);

exports.default = _default;